import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTrendingDown(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 55 31" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={5}
        d="M36.8 28.44h15.022m0 0V13.418m0 15.022L30.541 7.16 18.648 19.052 3 3.403"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTrendingDown);
export default ForwardRef;
